export type AutoDealerNavItem = { resource: string; label: string };

export type AutoDealerSalesNavSection = {
    sectionLabel: string;
    items: AutoDealerNavItem[];
};

/** Sales module destinations (Auto Dealers workspace), grouped like Setup. */
export const AUTO_DEALER_SALES_NAV_SECTIONS: AutoDealerSalesNavSection[] = [
    {
        sectionLabel: 'Vehicle',
        items: [
            { resource: 'dispatchInfo', label: 'Vehicle Dispatch' },
            { resource: 'vehicleReceivedInfo', label: 'Vehicle Received' },
            { resource: 'vehicleCommitmentInfo', label: 'Vehicle Commitment' },
            { resource: 'vehicleSaleInfo', label: 'Vehicle Sale' },
            { resource: 'vehicleTransferOtherOutlet', label: 'Transfer (Other Outlet)' },
            { resource: 'vehicleRecoveryInfo', label: 'Vehicle Recovery' },
            { resource: 'vehicleServicePayment', label: 'Services Bills' },
        ],
    },
    {
        sectionLabel: 'Payments',
        items: [{ resource: 'paymentToPsmc', label: 'Payment to Vendor' }],
    },
    {
        sectionLabel: 'Authorities',
        items: [
            { resource: 'authorityLetter', label: 'Authority Letter' },
            { resource: 'papersInHand', label: 'Papers in Hand' },
        ],
    },
];

/** Flat list (backwards compatible import). */
export const AUTO_DEALER_SALES_NAV: AutoDealerNavItem[] = AUTO_DEALER_SALES_NAV_SECTIONS.flatMap(
    s => s.items
);

/** Resources that have real list/create/edit screens — do not register a second placeholder `<Resource>`. */
export const AUTO_DEALER_SALES_IMPLEMENTED = new Set<string>([
    'vehicleCommitmentInfo',
    'vehicleSaleInfo',
    'dispatchInfo',
    'vehicleReceivedInfo',
    'vehicleTransferOtherOutlet',
    'paymentToPsmc',
    'vehicleServicePayment',
    'papersInHand',
    'authorityLetter',
]);
